import { ReactNode, useState } from "react";
import { cn } from "~/design-system/lib/utils";

type TooltipPropsType = {
  component: ReactNode;
  text: ReactNode;
  className?: string; // for Tooltip container
  classes?: {
    container?: string;
    tooltip?: string;
  };
};

export function Tooltip({
  component,
  text,
  className,
  classes,
}: TooltipPropsType) {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  return (
    <div
      onMouseOver={() => setIsVisible(true)}
      onFocus={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
      onBlur={() => setIsVisible(false)}
      className={cn("relative my-auto", classes?.container, className)}
    >
      <div
        className="inline cursor-pointer text-secondary"
        // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
      >
        {component}
      </div>
      <div
        className={cn(
          "absolute top-8 z-30 w-[260px] rounded-xl border border-emperor bg-white p-4 font-SF-Pro text-sm font-light text-smoky-black duration-300 ltr:left-0 rtl:right-0",
          isVisible ? "visible opacity-100" : "invisible opacity-0",
          classes?.tooltip,
        )}
      >
        {text}
      </div>
    </div>
  );
}
